import { render } from "./ChatResourceUploadView.vue?vue&type=template&id=4210e396"
import script from "./ChatResourceUploadView.vue?vue&type=script&lang=js"
export * from "./ChatResourceUploadView.vue?vue&type=script&lang=js"

import "./ChatResourceUploadView.vue?vue&type=style&index=0&id=4210e396&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__